import { useEffect, useRef, useState, useMemo, useCallback } from "react";
import { WorkOrder } from "../../Models/WorkOrder";
import moment from "moment";
import { ThreeCircles } from "react-loader-spinner";
import { Navbar } from "../../Components/Navbar/Navbar";
import { WORK_ORDER_ALL_ROUTE, WORK_ORDER_ROUTE } from "../../Constants/ROUTE_PATH_TITLES";
import "./WorkOrdersAll.scss";
import { GlobalState } from "../../Redux/reducers";
import { useSelector } from "react-redux";
import { ExportBillPopUp } from "../../Components/PopUps/ExportBillPopUp/ExportBillPopUp";
import { useNavigate } from "react-router";
import useWorkOrder from "../../hooks/useWorkOrder";
import { API_LIMIT } from "../../Constants/ENUMS";
import { useReactTable, getCoreRowModel, getSortedRowModel, flexRender, createColumnHelper, SortingState } from "@tanstack/react-table";
import { Tooltip as ReactTooltip } from "react-tooltip";

const date = new Date();

const numberWithCommas = (x: number) => {
  return (Math.round(x * 100) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const WorkOrdersAll = () => {
  const [workOrders, setWorkOrders] = useState<{ customerName: string; customerAddress: string; workOrder: WorkOrder }[]>([]);
  const [pageCount, setPageCount] = useState<number>(1);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [sorting, setSorting] = useState<SortingState>([]);

  const [exportedContent, setExportedContent] = useState<{ children: React.ReactNode | undefined; workOrderDesc: string }>();

  const currencygeneral: number = useSelector((state: GlobalState) => state.currency.rate);

  const { workOrdersLoading, getAllWorkOrders } = useWorkOrder();
  const timerRef = useRef<number | undefined>(undefined);

  const navigate = useNavigate();

  const exportComponent = useCallback(
    (workOrder: WorkOrder, customerName: string, customerAddress: string) => {
      const currency = workOrder.currency === "EUR" ? 1 : currencygeneral;

      const sumValuesofOrder = workOrder.productsToBeSold
        .map((item) => {
          return item.product.pricePerAmount * item.toBeSoldAmount;
        })
        .reduce((a, b) => a + b, 0);

      const sumValuesofWork = workOrder.workToBeSold
        .map((item) => {
          return item.workPrice * item.workingHours;
        })
        .reduce((a, b) => a + b, 0);

      return (
        <div className="pdfWrapper">
          {workOrder !== undefined ? (
            <>
              <div className="pdfInfoWrapper">
                <div>
                  <div className="pdfOrderCardcustomerDetailsHeaderWrapper">
                    <div className="orderCardcustomerDetailsHeader">{customerName}</div>
                    <div className="customerDetailsId">{customerAddress}</div>
                  </div>

                  <span className="pdfInfoLeftItemsWrapper">
                    <div className="pdfInfoLeftItem">
                      <span className="pdfInfoLeftHeader">İŞ EMRİ NO </span>
                      <span className="pdfInfoLeftValue">{workOrder._id}</span>
                    </div>
                    <div className="pdfInfoLeftItem">
                      <span className="pdfInfoLeftHeader">MAKİNE </span>
                      <span className="pdfInfoLeftValue">
                        {workOrder.Machine.brand} - {workOrder.Machine.modal}
                      </span>
                    </div>
                    <div className="pdfInfoLeftItem">
                      <span className="pdfInfoLeftHeader">SAAT </span>
                      <span className="pdfInfoLeftValue">{workOrder.hoursWorkedOnMachine}</span>
                    </div>
                    <div className="pdfStatusWrapper">{workOrder.status === "OFFER" ? "TEKLİF" : workOrder.status === "OPEN" ? "AÇIK" : "KAPALI"}</div>
                  </span>
                </div>
                <div className="pdfInfoRight">
                  <div className="pdfInfoRightWrapper">
                    <span className="pdfInfoRightItem">
                      <span className="pdfInfoRightHeader">İSKONTO TUTARI </span>
                      <span className="pdfInfoRightValue">
                        {numberWithCommas(
                          Math.round(
                            (sumValuesofOrder * (workOrder.percentages.piecePercentage / 100) + sumValuesofWork * (workOrder.percentages.workerPercentage / 100)) * currency * 100
                          ) / 100
                        )}
                      </span>
                    </span>
                    <span className="pdfInfoRightItem">
                      <span className="pdfInfoRightHeader">FATURA TARİH </span>
                      <span className="pdfInfoRightValue">{moment(workOrder.bill ? workOrder.bill.date : date).format("DD/MM/YYYY")}</span>
                    </span>
                    <span className="pdfInfoRightItem">
                      <span className="pdfInfoRightHeader">VADE </span>
                      <span className="pdfInfoRightValue">{workOrder.paymentExpiration}</span>
                    </span>
                    <span className="pdfInfoRightItem">
                      <span className="pdfInfoRightHeader">ÖDEME TARİHİ </span>
                      <span className="pdfInfoRightValue">
                        {moment(workOrder.bill ? workOrder.bill.date : date)
                          .add(workOrder.paymentExpiration, "days")
                          .format("DD/MM/YYYY")}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="pdftableWrapper">
                <table>
                  <thead>
                    <tr>
                      <th className="pdfthDescription">Açıklama</th>
                      <th className="pdfthAmount">Adet</th>
                      <th className="pdftableBorder">Birim Liste</th>
                      <th className="pdftableBorder">Birim Fiyat</th>
                      <th className="pdftableBorder">Toplam Fiyat</th>
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      {workOrder.productsToBeSold.map((productToSell, index) => {
                        return (
                          <tr key={index}>
                            <td className="pdftdDescription">
                              {productToSell.productCode} - {productToSell.productName} {productToSell.product.shelf ?? ""}
                            </td>
                            <td>{productToSell.toBeSoldAmount}</td>
                            <td>{numberWithCommas(Math.round(productToSell.product.pricePerAmount * currency * 100) / 100)}</td>
                            <td>
                              {numberWithCommas(Math.round(productToSell.product.pricePerAmount * ((100 - workOrder.percentages.piecePercentage) / 100) * currency * 100) / 100)}
                            </td>
                            <td>
                              {numberWithCommas(
                                Math.round(
                                  productToSell.product.pricePerAmount * ((100 - workOrder.percentages.piecePercentage) / 100) * productToSell.toBeSoldAmount * currency * 100
                                ) / 100
                              )}
                            </td>
                          </tr>
                        );
                      })}
                      {workOrder.workToBeSold.map((workToSell, index) => {
                        return (
                          <tr key={index}>
                            <td className="pdftdDescription">
                              {workToSell.workCode} - {workToSell.description}
                            </td>
                            <td>{workToSell.workingHours}</td>
                            <td>{numberWithCommas(Math.round(workToSell.workPrice * currency * 100) / 100)}</td>
                            <td>{numberWithCommas(Math.round(workToSell.workPrice * ((100 - workOrder.percentages.piecePercentage) / 100) * currency * 100) / 100)}</td>
                            <td>
                              {numberWithCommas(
                                Math.round(workToSell.workPrice * ((100 - workOrder.percentages.piecePercentage) / 100) * currency * workToSell.workingHours * 100) / 100
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  </tbody>
                </table>
              </div>

              <div className="pdfBottomInfoWrapper">
                <div style={{ display: "flex" }}>
                  <div>
                    <div className="pdfnoteInfo">
                      NOT TL OLARAK YAPILACAK ÖDEMELERDE AYNI GÜNÜN <br /> K.K.T.C MERKEZ BANKASI EFEKTİF SATIŞ KURU GEÇERLİDİR.
                    </div>
                    <div>
                      <span>
                        <span className="pdfbillIBAN">GARANTİ BANKASI TL </span>
                        <span>TR60 0006 2000 4930 0006 2802 54</span>
                      </span>
                    </div>
                    <div>
                      <span>
                        <span className="pdfbillIBAN">GARANTİ BANKASI EURO</span>
                        <span>TR33 0006 2000 4930 0009 0504 78</span>
                      </span>
                    </div>
                  </div>
                  <span className="pdfcalcWrapper">
                    <span>
                      <div>
                        <span className="pdfcalcHeader">TOPLAM </span>
                        <span>
                          {numberWithCommas(
                            Math.round(
                              (sumValuesofOrder * ((100 - workOrder.percentages.piecePercentage) / 100) +
                                sumValuesofWork * ((100 - workOrder.percentages.workerPercentage) / 100)) *
                                currency *
                                100
                            ) / 100
                          )}
                          {workOrder.currency === "EUR" ? <>€</> : <>₺</>}
                        </span>
                      </div>
                      <div className="pdfcalculationEnd">
                        <span className="pdfcalcHeader">KDV %{workOrder.percentages.KDVPercentage}</span>
                        <span>
                          {numberWithCommas(
                            Math.round(
                              (sumValuesofOrder * ((100 - workOrder.percentages.piecePercentage) / 100) +
                                sumValuesofWork * ((100 - workOrder.percentages.workerPercentage) / 100)) *
                                (workOrder.percentages.KDVPercentage / 100) *
                                currency *
                                100
                            ) / 100
                          )}
                          {workOrder.currency === "EUR" ? <>€</> : <>₺</>}
                        </span>
                      </div>
                      <div style={{ fontWeight: 600 }}>
                        <span className="pdfcalcHeader">TOPLAM </span>
                        <span>
                          {numberWithCommas(
                            Math.round(
                              (sumValuesofOrder * ((100 - workOrder.percentages.piecePercentage) / 100) +
                                sumValuesofWork * ((100 - workOrder.percentages.workerPercentage) / 100)) *
                                ((workOrder.percentages.KDVPercentage + 100) / 100) *
                                currency *
                                100
                            ) / 100
                          )}
                          {workOrder.currency === "EUR" ? <>€</> : <>₺</>}
                        </span>
                      </div>
                    </span>
                  </span>
                </div>

                <span className="pdfsignatureWrapper">
                  <span>
                    <div>Teslim eden</div>
                    <div>Serdar Özkan</div>
                  </span>
                  <span>Teslim Alan</span>
                </span>
              </div>
            </>
          ) : null}
        </div>
      );
    },
    [currencygeneral]
  );

  // Column helper
  const columnHelper = createColumnHelper<any>();

  // Tablo için veri hazırlama
  const tableData = useMemo(() => {
    return workOrders.map((item) => ({
      ...item,
      status: item.workOrder.status,
      customerName: item.customerName,
      workOrderId: item.workOrder._id,
      machine: item.workOrder.Machine.modal,
      description: item.workOrder.description,
      billDate: item.workOrder.bill ? moment(item.workOrder.bill.date).format("DD/MM/YYYY") : "",
      totalPrice: numberWithCommas(item.workOrder.totalPrice),
    }));
  }, [workOrders]);

  // Kolon tanımları
  const columns = useMemo(
    () => [
      columnHelper.accessor("status", {
        header: "Durum",
        cell: (info: any) => {
          const status = info.getValue();
          return (
            <svg width="30" height="30" viewBox="0 0 20 20" fill={status === "OFFER" ? "yellow" : status === "OPEN" ? "rgb(187, 1, 1)" : "gray"} xmlns="http://www.w3.org/2000/svg">
              <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z" />
              <path d="M10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15Z" />
            </svg>
          );
        },
      }),
      columnHelper.accessor("customerName", {
        header: "Müşteri",
        cell: (info: any) => (
          <div className="workorderAllTableDesc" data-tooltip-id={`customerTooltip-${info.row.index}`} title={info.getValue()}>
            {info.getValue()}
          </div>
        ),
      }),
      columnHelper.accessor("workOrderId", {
        header: "Numara",
        cell: (info: any) => info.getValue(),
      }),
      columnHelper.accessor("machine", {
        header: "Makine",
        cell: (info: any) => info.getValue(),
      }),
      columnHelper.accessor("description", {
        header: "Açıklama",
        cell: (info: any) => (
          <div className="workorderAllTableDesc" data-tooltip-id={`descriptionTooltip-${info.row.index}`} title={info.getValue()}>
            {info.getValue()}
          </div>
        ),
      }),
      columnHelper.accessor("billDate", {
        header: "Fatura Tarih",
        cell: (info: any) => info.getValue(),
      }),
      columnHelper.accessor("totalPrice", {
        header: "Toplam Tutar",
        cell: (info: any) => info.getValue(),
      }),
      columnHelper.display({
        id: "pdf",
        header: "PDF",
        cell: (info: any) => {
          const { workOrder, customerName, customerAddress } = info.row.original;
          return (
            <button
              className="exportBtn"
              onClick={() => {
                setExportedContent({
                  children: exportComponent(workOrder, customerName, customerAddress),
                  workOrderDesc: workOrder.description,
                });
              }}
            >
              PDF
            </button>
          );
        },
      }),
      columnHelper.display({
        id: "firmayaGit",
        header: "Firmaya Git",
        cell: (info: any) => {
          const { workOrder } = info.row.original;
          return (
            <div className="workorderAllTableCustomer">
              <button
                style={{ marginRight: "1rem" }}
                onClick={() => navigate(`${WORK_ORDER_ROUTE.PATH}/${workOrder._customerId}/WorkOrders/${workOrder.status === "CLOSED" ? 0 : workOrder._id}`)}
                className="cssbuttons-io-button"
              >
                Firma
                <div className="icon">
                  <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z" fill="currentColor"></path>
                  </svg>
                </div>
              </button>
            </div>
          );
        },
      }),
    ],
    [columnHelper, navigate, setExportedContent, exportComponent]
  );

  // React Table instance
  const table = useReactTable({
    data: tableData,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  useEffect(() => {
    if (searchTerm.length === 0) {
      getAllWorkOrders(pageCount, API_LIMIT, searchTerm)
        .then((result) => {
          if (pageCount === 1) {
            setWorkOrders(result);
          } else {
            setWorkOrders(workOrders.concat(result));
          }
        })
        .catch((err) => console.error(err));
    }
    if (searchTerm.length > 2) {
      if (timerRef.current) window.clearTimeout(timerRef.current);

      timerRef.current = window.setTimeout(() => {
        getAllWorkOrders(pageCount, API_LIMIT, searchTerm)
          .then((result) => {
            if (pageCount === 1) {
              setWorkOrders(result);
            } else {
              setWorkOrders(workOrders.concat(result));
            }
          })
          .catch((err) => console.error(err));
      }, 600);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageCount, searchTerm]);

  return (
    <div>
      <Navbar />

      <div className="workOrderAllWrapper">
        <div className="workOrderAllHeaderWrapper">
          <h1 className="workOrderAllHeader">{WORK_ORDER_ALL_ROUTE.TITLE}</h1>
        </div>
        <div className="searchLoaderWrapper">
          <div className="group">
            <svg viewBox="0 0 24 24" fill="white" aria-hidden="true" className="searchIcon">
              <g>
                <path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path>
              </g>
            </svg>
            <input
              onChange={(e) => {
                setSearchTerm(e.target.value.toUpperCase());
                setPageCount(1);
              }}
              className="input"
              type="text"
              placeholder="Ara..."
            />
          </div>
          {workOrdersLoading ? (
            <div className="LoaderWrapperWorkOrder">
              <ThreeCircles height="60" width="60" color="var(--primary-color)" />
            </div>
          ) : null}
        </div>

        <div className="workOrderAllTableWrapper">
          {exportedContent ? (
            <ExportBillPopUp fileName={exportedContent.workOrderDesc} close={() => setExportedContent(undefined)}>
              {exportedContent.children}
            </ExportBillPopUp>
          ) : null}
          <table className="fl-table">
            <thead>
              {table.getHeaderGroups().map((headerGroup: any) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header: any) => (
                    <th
                      key={header.id}
                      className={`sortable-header ${header.column.getIsSorted() ? "sorted" : ""}`}
                      style={{ cursor: "pointer", userSelect: "none" }}
                      onClick={header.column.getToggleSortingHandler()}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                        {header.column.getIsSorted() === "asc" ? (
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M7 14l5-5 5 5z" />
                          </svg>
                        ) : header.column.getIsSorted() === "desc" ? (
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M7 10l5 5 5-5z" />
                          </svg>
                        ) : (
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" style={{ opacity: 0.3 }}>
                            <path d="M7 10l5 5 5-5z" />
                          </svg>
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.map((row: any) => (
                <tr key={row.id}>
                  {row.getVisibleCells().map((cell: any) => (
                    <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          <button onClick={() => setPageCount(pageCount + 1)} className="loadMoreButton">
            Daha fazla yükle
          </button>
        </div>
      </div>

      {/* Tooltips */}
      {tableData.map((item, index) => (
        <ReactTooltip
          key={`tooltip-${index}`}
          style={{ color: "black", zIndex: 5, width: "15rem", whiteSpace: "normal", fontSize: "1rem", wordBreak: "break-word" }}
          variant="info"
          id={`customerTooltip-${index}`}
          place="bottom"
          content={item.customerName}
        />
      ))}
      {tableData.map((item, index) => (
        <ReactTooltip
          key={`desc-tooltip-${index}`}
          style={{ color: "black", zIndex: 5, width: "15rem", whiteSpace: "normal", fontSize: "1rem", wordBreak: "break-word" }}
          variant="info"
          id={`descriptionTooltip-${index}`}
          place="bottom"
          content={item.description}
        />
      ))}
    </div>
  );
};
